import Image from "next/image";
import React from "react";

/**
 * SectionFooter Component
 * Footer with company information and links
 */
const SectionFooter: React.FC = () => {
  const logoUrl = "/image/logo.webp";

  const footerLinks = [
    "Pekalen Atas",
    "Pekalen Bawah",
    "Penginapan",
    "Paint Ball",
    "Outbound Training",
  ];

  return (
    <div className="bg-base-black w-full font-family-open-sans">
      <div className="flex flex-col px-6 md:px-8 lg:px-0 max-w-6xl lg:mx-auto">
        {/* Top Section */}
        <div className="flex flex-col py-8 lg:py-16">
          <div className="flex flex-wrap md:flex-nowrap text-center md:text-left justify-between gap-6 md:gap-8">
            {/* Column 1 - About */}
            <div className="w-full lg:w-3/12">
              <p className=" text-lg text-[#2ea3f2] mb-[10.6px]">
                Pekalen Rafting Probolinggo
              </p>
              <p className=" text-sm leading-[23.8px] text-white m-0">
                Kami operator resmi wisata arung jeram sungai Pekalen, mengusung
                konsep Go Green, kami memiliki basecamp yang representative,
                rest area yang indah dengan fasilitas ayunan (swing). Tidak lupa
                arung jeram di Pekalen Rafting sudah include dokumentasi foto
                dan video.
              </p>
            </div>

            {/* Column 2 - Company */}
            <div className="w-full lg:w-4/12">
              <p className=" text-lg text-[#2ea3f2] mb-[10.6px]">
                CV. Citra Alam Mulia Probolinggo
              </p>
              <p className=" text-[13.9px] leading-[23.8px] text-white m-0">
                Jl. Raya Pesawahan, Asinan, Pesawahan
                <br />
                Kec. Tiris, Kabupaten Probolinggo, Jawa Timur
                <br />
                E-mail : pekalenraftingofficial@gmail.com
                <br />
                Whatsapp : 08123593150
              </p>
            </div>

            {/* Column 3 - Payment */}
            <div className="w-full lg:w-2/12 items-end">
              <p className=" text-lg text-[#2ea3f2] mb-[10.6px]">
                Rekening Pembayaran
              </p>
              <p className=" text-sm leading-[23.8px] text-white m-0">
                <strong>Bank Central Asia (BCA)</strong>
                <br />
                No Rekening 2015776666
                <br />
                a/n: Citra Alam Mulia Probolinggo
              </p>
            </div>
          </div>
        </div>
        {/* Middle Section */}
        <div className="flex flex-col md:flex-row py-4 gap-3 items-center md:justify-between">
          <Image
            width={100}
            height={100}
            src={logoUrl}
            alt="Pekalen Rafting Probolinggo"
            className="h-[36.17px] w-[186.8px] cursor-pointer"
          />

          {/* Copyright */}
          <p className="font-arial text-[12.25px] leading-[17.5px] text-[#99a1af] text-center md:text-right m-0">
            © 2026 Pekalen Rafting. All rights reserved.
            <br className="md:hidden" />
            <span className="hidden md:inline">&nbsp;</span>
            Privacy Policy | Terms of Service
          </p>
        </div>
      </div>
      {/* Links Section */}
      {/* <div className="bg-[#fbe64b]">
        <div className="flex gap-3 md:gap-4 py-2 px-6 md:px-8 lg:px-0 max-w-6xl lg:mx-auto flex-wrap md:flex-nowrap justify-around md:justify-center lg:justify-start bg-[#fbe64b]">
          {footerLinks.map((link, index) => (
            <p
              key={index}
              className="font-semibold text-sm leading-[23.8px] text-[#222222] cursor-pointer m-0 hover:underline transition-all"
            >
              {link}
            </p>
          ))}
        </div>
      </div> */}

      {/* Bottom Bar */}
      {/* <div className="bg-base-black py-4 px-6 md:px-8 lg:px-0 max-w-6xl lg:mx-auto">
        <p className=" text-sm leading-[23.8px] text-white m-0 text-center lg:text-left">
          Copyright © 2026 Pekalen Rafting

        </p>
      </div> */}
    </div>
  );
};

export default SectionFooter;
